export enum RewardShop {
  INDEX = '/reward-shop',
  ARCHIVE = '/reward-shop/archive',
  CREATE = '/reward-shop/create',
  EDIT = '/reward-shop/edit',
}
